// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__4zmlP","icon":"Contact_icon__uPRlS","iconResume":"Contact_iconResume__5x-Gb","iconText":"Contact_iconText__1faxd"};